// src/Footer.js
import React, { useState, useEffect, useRef } from 'react';
import ReactAudioPlayer from 'react-audio-player';


let loadPage = true;
const Footer = () => {

    const [visitDaily, SetVisitDaily] = useState(null);
    const [visitWeekly, SetVisitWeekly] = useState(null);
    const [visitMounty, SetMounty] = useState(null);
    const [visitYearly, SetYearly] = useState(null);
    const [surveySangatPuas, SetSangatPuas] = useState(null);
    const [surveyPuas, SetPuas] = useState(null);
    const [surveyKurangPuas, SetKurangPuas] = useState(null);
    const [surveyTidakPuas, SetTidakPuas] = useState(null);

    const audioRef = useRef(null);

    const playAudio = () => {
        audioRef.current.play();
    };

    const [isOpen, setIsOpen] = useState(false);

    const openPopup = (e) => {
        e.preventDefault(); // mencegah link default
        window.open(
            e.currentTarget.href,
            'popupWindow',
            'width=600,height=400'
        );
      };

    const handleGetData = async () => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/visitor`)
        .then((response) => response.json())
        .then((res) => {
            SetVisitDaily(res.data.visit_daily);
            SetVisitWeekly(res.data.visit_weekly);
            SetMounty(res.data.visit_mounty);
            SetYearly(res.data.visit_yearly);
            console.log(res.data);
        });

        fetch(`${process.env.REACT_APP_API_ENDPOINT}/survey`)
        .then((response) => response.json())
        .then((res) => {
            SetSangatPuas(res.data.sangat_puas);
            SetPuas(res.data.puas);
            SetKurangPuas(res.data.kurang_puas);
            SetTidakPuas(res.data.tidak_puas);
        });
    }

    useEffect(() => {
        if (loadPage) {
            handleGetData();
        }
        return () => {
            loadPage = false
        };
    }, []);

    return (
        <div className="max-w-full mx-auto bg-sky-50 pt-5">
            <footer className="max-w-[1400px] mx-auto bg-[#FF3C3C] text-white py-8 rounded-t-[40px]">
                <div className="container mx-auto">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 max-w-screen-lg mx-auto">

                        <div className='w-[200px] p-0'>
                            <h3 class="text-lg mb-4" style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>MAIN MENU</h3>
                            <ul class="space-y-2" style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 13, listStyleType: 'none' }}>
                                <li><a href="/" class="hover:underline">Home</a></li>
                                <li><a href="/about" class="hover:underline">Profil Kami</a></li>
                                <li><a href="/pencarian-produk-hukum/peraturan-daerah" class="hover:underline">Peraturan Perundangan</a></li>
                                <li><a href="/berita" class="hover:underline">Berita</a></li>
                                <li><a href="/pencarian-produk-hukum/putusan" class="hover:underline">Putusan</a></li>
                            </ul><br /><br /><br /><br />
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3955.6480483958426!2d110.218716514724!3d-7.504050194587336!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e7a8f3adfa7c4ff%3A0x6397035efc467592!2sJl.%20Jend.%20Sarwo%20Edhie%20Wibowo%20No.2%2C%20Tenjosari%2C%20Banyurojo%2C%20Kec.%20Mertoyudan%2C%20Kabupaten%20Magelang%2C%20Jawa%20Tengah%2056101!5e0!3m2!1sid!2sid!4v1663913317727!5m2!1sid!2sid" width="760" height="250" class="rounded-xl" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>

                        <div className='w-[390px] p-0'>
                            <h3 class="text-lg mb-4" style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>MEDIA SOSIAL</h3>
                            <ul class="space-y-2" style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 13, listStyleType: 'none' }}>
                                <li>
                                    <div class="w-[300px] h-[246px] text-white p-4 flex flex-col gap-6">
                                        <div class="flex items-center gap-3">
                                            <img src="https://img.icons8.com/?size=100&id=cs0F7pb81QnM&format=png&color=000000" alt="YouTube" class="w-8 h-8" />
                                            <span class="text-lg">JDIH Kota Magelang</span>
                                        </div>
                                        <div class="flex items-center gap-3">
                                            <img src="https://img.icons8.com/?size=100&id=13912&format=png&color=000000" alt="YouTube" class="w-8 h-8" />
                                            <span class="text-lg">JDIH Indonesia</span>
                                        </div>
                                        <div class="flex items-center gap-3">
                                            <img src="https://img.icons8.com/?size=100&id=Xy10Jcu1L2Su&format=png&color=000000" alt="YouTube" class="w-8 h-8" />
                                            <span class="text-lg">@Jdihkotamagelang</span>
                                        </div>
                                    </div>
                                </li>
                            </ul>

                        </div>

                        <div className='w-[390px] p-1'>
                            <h3 class="text-lg mb-4" style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>CONTACT US</h3>
                            <ul class="space-y-2" style={{ listStyleType: 'none' }}>
                                <li><p style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 12 }}> Bagian Hukum Setda Kota Magelang <br /> Jl. Jend. Sarwo Edhie Wibowo No.2 <br />Kota Magelang</p></li>
                                <li><p style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 12 }}>Telepon: (0293) 363695</p></li>
                                <li><p style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 12 }}>Faksimili: (0293) 364910 </p></li>
                                <li><p style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 12 }}>Email : </p></li>
                                <li><p style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 12 }}>hukumkotamagelang@gmail.com <br />jdihkotamagelang@gmail.com</p></li>
                            </ul>
                        </div>      

                        <div className='w-[390px] p-1'>
                            <h3 class="text-lg mb-4" style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>STATISKTIK PENGUNJUNG</h3>
                            <ul class="space-y-2 mx-auto" style={{ fontFamily: 'MuseoSansRounded700', fontSize: 13, listStyleType: 'none' }}>
                                <li>
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>Daily</div>
                                        <div><span class="w-[60px] inline-flex items-center rounded-md bg-[#aed6f1] px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">{visitDaily}</span></div>
                                    </div>
                                </li>
                                <li>
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>Weekly</div>
                                        <div><span class="w-[60px] inline-flex items-center rounded-md bg-[#d1f2eb] px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">{visitWeekly}</span></div>
                                    </div>
                                </li>
                                <li>
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>Mountly</div>
                                        <div><span class="w-[60px] inline-flex items-center rounded-md bg-[#fad7a0] px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">{visitMounty}</span></div>
                                    </div>
                                </li>
                                <li>
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>Yearly</div>
                                        <div><span class="w-[60px] inline-flex items-center rounded-md bg-[#5d6d7e] px-2 py-1 text-xs font-medium text-white-600 ring-1 ring-gray-500/10 ring-inset">{visitYearly}</span></div>
                                    </div>
                                </li>
                            </ul> <br />

                            <h3 class="text-lg mb-4" style={{ color: '#ffffff', fontFamily: 'MuseoSansRounded700', fontSize: 18, paddingLeft: 20 }}>SURVEY KEPUASAN</h3>
                            <ul class="space-y-2 mx-auto" style={{ fontFamily: 'MuseoSansRounded700', fontSize: 13,  listStyleType: 'none' }}>
                                <li>
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>Sangat Puas</div>
                                        <div><span class="w-[60px] inline-flex items-center rounded-md bg-[#aed6f1] px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">{surveySangatPuas}</span></div>
                                    </div>
                                </li>
                                <li>
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>Puas</div>
                                        <div><span class="w-[60px] inline-flex items-center rounded-md bg-[#d1f2eb] px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">{surveyPuas}</span></div>
                                    </div>
                                </li>
                                <li>
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>Kurang Puas</div>
                                        <div><span class="w-[60px] inline-flex items-center rounded-md bg-[#fad7a0] px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset">{surveyKurangPuas}</span></div>
                                    </div>
                                </li>
                                <li>
                                    <div class="grid grid-cols-2 gap-4">
                                        <div>Tidak Puas</div>
                                        <div><span class="w-[60px] inline-flex items-center rounded-md bg-[#5d6d7e] px-2 py-1 text-xs font-medium text-white-600 ring-1 ring-gray-500/10 ring-inset">{surveyTidakPuas}</span></div>
                                    </div>
                                </li>
                                <li>&nbsp;</li>
                                <li>
                                    RADIO 103.5 MAGELANG FM <br />
                                    <a
                                        href="http://p.onlineradiobox.com/id/magelangfm/player/?cs=id.magelangfm&played=1&from_widget=1"
                                        onClick={openPopup}
                                    >
                                        <div class="w-[159px] h-[88px] rounded-lg bg-gradient-to-b from-[#3a3a3a] to-[#1b1b1b] flex items-center justify-center relative">
                                            <div class="w-[70px] h-[70px] bg-[#00629a] rounded-full flex items-center justify-center border-[6px] border-[#4a4a4a] shadow-inner">
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M15.91 11.672a.375.375 0 0 1 0 .656l-5.603 3.113a.375.375 0 0 1-.557-.328V8.887c0-.286.307-.466.557-.327l5.603 3.112Z" />
                                                </svg>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>

                            {isOpen && (
                                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                                    <div className="relative bg-white w-full max-w-lg p-6 rounded-lg shadow-lg">
                                        {/* Tombol Close */}
                                        <button
                                            onClick={() => setIsOpen(false)}
                                            className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                                        >
                                            ✕
                                        </button>

                                        {/* Judul */}
                                        <h2 className="text-xl font-bold mb-4">Syarat dan Ketentuan</h2>

                                        {/* Isi Syarat */}
                                        <div className="h-60 overflow-y-auto mb-4 text-[8px] text-gray-700">
                                            <iframe src="http://p.onlineradiobox.com/id/magelangfm/player/?cs=id.magelangfm&played=1&from_widget=1" />
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div><br />
                    <div className="container mx-auto" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                        <img src="https://jdih.magelangkota.go.id/logo-header.png" alt="" class="h-[60px] shadow-xl" />
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;
